module.exports = __webpack_public_path__ + "img/파라솔 (1).30524da5.jpg";